import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import hideWithoutGiftCardSales from '../hoc/hideWithoutGiftCardSales';

const GiftCardMessage = ({ className }) => (
  <p className={cx('u-text-justify u-type--semibold epsilon u-co-black-2', className)}>
    Everyone can appreciate looking good and feeling good, so give yourself (or someone you love) the gift of grooming!
    Great for the holidays, special occasions, or any last minute gift ideas.
    Once you complete the purchase you will receive an email and text message with your
    Gift Card code that you will be able to use next time you are booking an appointment or paying at the shop.
  </p>
);

GiftCardMessage.propTypes = {
  className: PropTypes.string,
};

GiftCardMessage.defaultProps = {
  className: '',
};

export default hideWithoutGiftCardSales(GiftCardMessage);



// WEBPACK FOOTER //
// ./src/app/giftCard/GiftCardMessage/GiftCardMessage.jsx